import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {NoteRatingModule } from '../note-rating/note-rating.module';

import { RateNoteModalComponent } from './rate-note-modal.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCaretDown, faCaretUp, faInfoCircle, faSync } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

@NgModule({
    declarations: [ RateNoteModalComponent ],
    imports: [
        RouterModule,
        CommonModule,
        NoteRatingModule,
        NgbRatingModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule
    ],
    providers: [NgbActiveModal],
    exports: [ RateNoteModalComponent ]
})

export class RateNoteModalModule {
    constructor() {
        library.add(faSync, faCaretUp, faCaretDown, faInfoCircle);
      }
}
